
import forumContribute from './forumContribute/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  forumContribute
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/emojis/reducer.js
 **/